"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const is_hold_status_1 = require("@App/helpers/work-entities/utils/is-hold-status");
const Status_1 = __importDefault(require("@Components/Status"));
const HoldStatusIndicator = (props) => {
    const { holdStatus } = props;
    const status = (0, is_hold_status_1.getHoldText)(holdStatus);
    return status && react_1.default.createElement(Status_1.default, { status: status, circleFirst: true });
};
exports.default = HoldStatusIndicator;
